import React, { useMemo, useEffect, useCallback } from "react";
import {Box} from "@mui/material";
import { VariableSizeList as VirtualList } from "react-window";
import LoadingCircle from "../../../components/LayoutComponents/LoadingCircle";
import SkillCard from "./SkillCard";


export default function SkillsList({
  session, 
  skills,
  setSkills,
  proficiencies,
  handleProficiencyChange,
  newlyAddedSkills,
  isMobile,
  loading,
  setLoading
}) {

  
  useEffect(() => {
    if (skills?.length > 0) {
      setLoading(false);
    }else{
      setLoading(true)
    }
  }, [skills, setLoading]);
 
  const filteredSkills = useMemo(
    () => skills?.filter((s) => s.competencyId),
    [skills]
  );

  
  const getItemSize = useCallback(
    (index, isMobile) => {
      const skill = filteredSkills[index];
      if (!skill) return 100; 

      const words =
        (skill.competencyDescription?.split(" ").length || 0) +
        (skill.originalStatement?.split(" ").length || 0);

      const baseHeight = isMobile? 300:150;
      const wordsPerLine = 5;
      const lineHeight = 30;
      const gap = 50;

      const extraLines = Math.max(1, Math.ceil(words / wordsPerLine));
      return baseHeight + extraLines * lineHeight + gap;
    },
    [filteredSkills, isMobile]
  );

  

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 400,
        }}
      >
        <LoadingCircle />
      </Box>
    );
  }

  return (
    <VirtualList
      height={400}
      width="100%"
      itemCount={filteredSkills.length}
      itemSize={getItemSize}
      itemData={{
        setLoading,
        session,
        skills: filteredSkills,
        setSkills,
        proficiencies,
        handleProficiencyChange,
        newlyAddedSkills,
      }}
      overscanCount={5}
    >
      {SkillCard}
    </VirtualList>
  );
}